// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import Navbar from "@/components/Navbar";
import moment from "moment";
import { format, parseISO } from "date-fns";

export default {
  name: "Transactions",
  components: {
    Navbar,
  },
  data() {
    return {
      snackbar: false,
      snackbar_text: '',
      snackbar_timeout: 2000,
      search: "",
      loading: true,
      payment_provider: "",
      selected_filter: "",
      showFilters: false,
      loading_data: true,
      transaction_logs: [],
      provider_list: [],
      itemsPerPage: 10,
      selected: [],
      columns: [
        { text: "Name", value: "customer_firstname" },
        { text: "Email", value: "customer_email" },
        { text: "Phone", value: "customer_phone" },
        { text: "Source", value: "payment_source" },
        { text: "Amount", value: "amount" },
        { text: "Basket ID", value: "payment_session_id" },
        { text: "Order Reference", value: "order_reference" },
        { text: "Response Status", value: "payment_status" },
        { text: "Response Detail", value: "response_message" },        
        { text: 'Transaction DateTime', value: 'created_at', width: '200px', dataType: "Date"},
      ],
      headers: [
        { text: "Name", value: "customer_firstname" },
        { text: "Email", value: "customer_email" },
        { text: "Phone", value: "customer_phone" },
        { text: "Source", value: "payment_source" },
        { text: "Amount", value: "amount" },
        { text: "Basket ID", value: "payment_session_id" },
        { text: "Order Reference", value: "order_reference" },
        { text: "Response Status", value: "payment_status" },
        { text: "Response Detail", value: "response_message" },        
        { text: 'Transaction DateTime', value: 'created_at', width: '200px', dataType: "Date"},
      ],
      menu1: false,
      menu2: false,
      start_date: format(parseISO(new Date().toISOString()), "yyyy-MM-dd"),
      end_date: format(parseISO(new Date().toISOString()), "yyyy-MM-dd"),
    };
  },

  computed: {
    startDateFormat() {
      return this.start_date
        ? moment(this.start_date).format("dddd, MMMM Do YYYY")
        : "";
    },
    endDateFormat() {
      return this.end_date
        ? moment(this.end_date).format("dddd, MMMM Do YYYY")
        : "";
    },
  },

  created() {
    this.initialize();
  },

  mounted() {},

  methods: {
    // Initialize Function
    initialize() {
      this.getlogs();
    },
    
    // Get Logs
    getlogs() {
      var a = moment(this.end_date)
      var b = moment(this.start_date)
      var no_of_days = a.diff(b, 'days')
      if (no_of_days < 0) {
        this.loading_data = false;
        this.snackbar = true;
        this.snackbar_text = "Invalid Date Range";
      } else {
        this.provider_filter = null;
        this.loading_data = true;
        this.$Axios.get(this.$backendURL + "/transactions?shop=" + this.$shop + "&start_date=" + this.start_date + "&end_date=" + this.end_date, {
          headers: {
            Authorization: this.$API_TOKEN.replace("%20", " "),
          },
        }).then(
          (response) => {
            this.transaction_logs = response.data.results;
            this.loading_data = false;
          },(error) => {
            if (error.response.data.detail == "Session expired, Reopen the application!") {
              this.$router.push("/error");
            }
          }
        );
      }
    },

    // Handle Filters
    handleFilterAdd(selected_filter, filter_type) {
      if (filter_type == "provider_filter") {
        if (this.selected_filter != "") {
          this.selected_filter +=","+ selected_filter;
        } else {
          this.selected_filter = selected_filter
        }
        alert(this.selected_filter)
      }

      this.loading_data = false;
      this.$Axios.get(this.$backendURL + "/transactions?shop=" + this.$shop + "&filter=" + this.selected_filter + "&start_date=" + this.start_date + "&end_date=" + this.end_date, {
        headers: {
          Authorization: this.$API_TOKEN.replace("%20", " "),
        },
      }).then(
        (response) => {
          this.transaction_logs = response.data.results;
          this.loading_data = false;
        },
        (error) => {
          console.log(error);
        }
      );
    },

    // Get Colors
    getColor(status) {
      if (status == "success") return "green";
      else return "orange";
    },

    // Row Actions
    rowAction(id, action) {
      console.log(id, action);
    },

    // Seach Funcation
    search(e) {
      var context = this;
      clearTimeout(context.searchDebounce);
      context.searchDebounce = setTimeout(() => {
        console.log(e);
      }, 1000);
    },

    // Header Change
    headerChange(checked, title) {
      var context = this;
      if (checked) {
        context.columns.forEach(function(column) {
          if (column.text === title) {
            context.headers.splice(context.headers.length - 1, 0, column);
          }
        });
      } else {
        context.headers.forEach(function(header, index) {
          if (header.text === title) {
            context.headers.splice(index, 1);
          }
        });
      }
    },
    
    // Download Logs
    downloadLogs() {
      var a = moment(this.end_date)
      var b = moment(this.start_date)
      var no_of_days = a.diff(b, 'days')
      if (no_of_days < 0) {
        this.loading_data = false;
        this.snackbar = true;
        this.snackbar_text = "Invalid Date Range";
      }
      else {
        window.open(this.$backendURL + "/transaction_logs_csv?shop=" + this.$shop + "&start_date=" + this.start_date + "&end_date=" + this.end_date + "&provider_filter=" + this.provider_filter);
      }
    },
  },
};
